import { EdgeProps } from "reactflow";
import BaseEdge from "./base/BaseEdge";

export const VendorIdEdge = (edgeProps: EdgeProps) => {
  return <BaseEdge {...edgeProps} color={"blue.400"} />;
};
